var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events container-fluid mx-auto",class:_vm.mode},[_c('div',{staticClass:"row no-gutters overflow-hidden"},[_c('EventList'),_c('EventContainer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }